import {_pHttp} from "../_pHttp";
// import { BASE_URL_API } from "../../CONSTANTS";


export type Operator = {
  id?: string;
  mobile: string;
  username: string;
  password: string;
  confirmPassword: string;
  f_name: string;
  l_name: string;
  personalCode: string;
  nationalCode: string;
  email: string;
  roleId: string;
  group: string;
  image: string;
};

export const getOperators =async ({page,search}:{page:string|number,search:string})=>{
  const {data} = await _pHttp.get(`/operator/get?page=${page}&search=${search}`)
    return data
}

export const getOperator =async ({id}:{id:string|number|undefined})=>{
  const {data} = await _pHttp.get(`/operator/${id}`)
    return data
}

export const addOperator =async (body:Operator)=>{
  //console.log("HOOK -> ",body)
  await _pHttp.post(`/operator/add`, body);
}

export const editOperators =async (body:Operator)=>{
  //const {id,...rest} = body
  await _pHttp.post(`/operator/edit`, body);
}

export const deleteOperators =async ({id}:{id:string|number})=>{
  const {data} = await _pHttp.delete(`/operator/delete/${id}`);
    return data
}

export  const resetPassword = async (body:{id:string,password:string,confirmPassword:string})=>{
  const {data} = await  _pHttp.post('/operator/resetpass',body)
  return data
}
